import { useDeselectOnEmptyClick } from 'hooks/useDeselectOnEmptyClick'
import { CANVAS_ITEM_FRAME_CLASS_NAME } from 'consts'
import {
  CANVAS_CONTAINER_ID,
  POSITIONED_MEDIA_CONTROLS_HOST_CLASS_NAME
} from '../../consts'

export const useDeselectCanvasItems = () =>
  useDeselectOnEmptyClick(CANVAS_CONTAINER_ID, [
    CANVAS_ITEM_FRAME_CLASS_NAME,
    POSITIONED_MEDIA_CONTROLS_HOST_CLASS_NAME
  ])
